import $$ from "cmn-utils";
const baseUrl = "/api/sys/unit/group/";
export default {
  list: (params) => {
    return $$.get(baseUrl + "list", params);
  },
};
